// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: '79c18eca-4112-45d5-aba5-a7096a83f9e7',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '6a5f396e-3cdf-4044-acc6-f557ea17a95b',
      type: 'Sprite',
      name: 'testSprite',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Shop_Close_Button',
      parent: '79c18eca-4112-45d5-aba5-a7096a83f9e7'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '3.1.0',
  animations: [
    {
      id: '6315aa02-b7ca-43da-990e-93b89712a2d7',
      name: 'Animation1',
      playingSpeed: 1,
      totalDuration: 1000,
      blocks: [
        {
          id: '978e2399-4b1f-40bb-8762-87fb3db26c26',
          type: 'Setter',
          name: 'New_setter',
          track: 1,
          target: {
            textureName: 'Coins_1',
            x: 500
          },
          startAt: 461,
          sourceName: 'testSprite',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class TestLayout {
  static raw = raw;
  root!: Container;
  testSprite!: Sprite;
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}

export abstract class Animation1 {
  Layout: {
    testSprite: object;
  };

  BlockTypeByName: {
    New_setter: object;
  };

  flowData = raw.animations[0];
}
